import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetAllLogisticsVehicleTypesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.VehicleTypeDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.VehicleTypeDocumentSortInput> | Types.VehicleTypeDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsVehicleTypesQuery = { __typename?: 'Query', logisticsVehicleTypes?: { __typename?: 'LogisticsVehicleTypesConnection', totalCount: number, nodes?: Array<{ __typename?: 'VehicleTypeDocument', id: string, tenantId: string, vehicleTypeId: string, name: string, notes: string, maxLoadWeight?: number | null, maxLoadWeightUnit: Types.WeightUnit, maxLoadWeightLbs?: number | null, updatedAt: Types.TDateISO, updatedBy: string, capacities: Array<{ __typename?: 'VehicleTypeCapacityData', containerConfigId: string, containerName: string, maxCount: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type LogisticsVehicleTypeDocumentFieldsFragment = { __typename?: 'VehicleTypeDocument', id: string, tenantId: string, vehicleTypeId: string, name: string, notes: string, maxLoadWeight?: number | null, maxLoadWeightUnit: Types.WeightUnit, maxLoadWeightLbs?: number | null, updatedAt: Types.TDateISO, updatedBy: string, capacities: Array<{ __typename?: 'VehicleTypeCapacityData', containerConfigId: string, containerName: string, maxCount: number }> };

export const LogisticsVehicleTypeDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsVehicleTypeDocumentFields on VehicleTypeDocument {
  id
  tenantId
  vehicleTypeId
  name
  notes
  capacities {
    containerConfigId
    containerName
    maxCount
  }
  maxLoadWeight
  maxLoadWeightUnit
  maxLoadWeightLbs
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsVehicleTypeDocumentFields"});
export const GetAllLogisticsVehicleTypesDocument = new TypedDocumentString(`
    query GetAllLogisticsVehicleTypes($where: VehicleTypeDocumentFilterInput, $order: [VehicleTypeDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsVehicleTypes(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsVehicleTypeDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsVehicleTypeDocumentFields on VehicleTypeDocument {
  id
  tenantId
  vehicleTypeId
  name
  notes
  capacities {
    containerConfigId
    containerName
    maxCount
  }
  maxLoadWeight
  maxLoadWeightUnit
  maxLoadWeightLbs
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllLogisticsVehicleTypes: build.query<GetAllLogisticsVehicleTypesQuery, GetAllLogisticsVehicleTypesQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsVehicleTypesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllLogisticsVehicleTypesQuery, useLazyGetAllLogisticsVehicleTypesQuery } = injectedRtkApi;
